// extracted by mini-css-extract-plugin
export default {"hr":"Style_hr__zhyUh"};